export default __webpack_public_path__ + "static/media/whatsapp.b1cce4d7.png";